import { Box, Skeleton } from '@mui/material';
import theme from '../../../theme';

const AgentMemorySkeleton = () => {
  return (
    <Box
      sx={{
        border: `1px solid ${theme.palette.lightGray?.main || '#DCE0E7'}`,
        borderRadius: '12px',
        height: '100%',
        maxHeight: 'calc(100vh - 300px)',
        overflow: 'auto !important',
      }}
    >
      {/* Header Row */}
      <Box
        sx={{
          display: 'flex',
          bgcolor: '#F8F9FC',
          borderBottom: `1px solid ${theme.palette.lightGray?.main || '#DCE0E7'}`,
        }}
      >
        <Box
          sx={{
            width: 180,
            padding: '12px 16px',
            color: 'custom.textBlue',
            fontSize: '14px',
            fontWeight: 600,
          }}
        >
          Created On
        </Box>
        <Box
          sx={{
            width: 180,
            padding: '12px 16px',
            color: 'custom.textBlue',
            fontSize: '14px',
            fontWeight: 600,
          }}
        >
          User Id
        </Box>
        <Box
          sx={{
            width: 180,
            padding: '12px 16px',
            color: 'custom.textBlue',
            fontSize: '14px',
            fontWeight: 600,
          }}
        >
          Topic
        </Box>
        <Box
          sx={{
            flex: 1,
            padding: '12px 16px',
            color: 'custom.textBlue',
            fontSize: '14px',
            fontWeight: 600,
          }}
        >
          Memory
        </Box>
        <Box
          sx={{
            width: 100,
            padding: '12px 16px',
            color: 'custom.textBlue',
            fontSize: '14px',
            fontWeight: 600,
          }}
        >
          Action
        </Box>
      </Box>

      {/* Data Rows */}
      {[...Array(8)].map((_, index) => (
        <Box
          key={index}
          sx={{
            display: 'flex',
            height: 60,
            borderBottom:
              index < 7
                ? `1px solid ${theme.palette.lightGray?.main || '#DCE0E7'}`
                : 'none',
          }}
        >
          <Box sx={{ width: 180, padding: '12px 16px' }}>
            <Skeleton variant="text" width={120} height={24} />
          </Box>
          <Box sx={{ width: 180, padding: '12px 16px' }}>
            <Skeleton variant="text" width={100} height={24} />
          </Box>
          <Box sx={{ width: 180, padding: '12px 16px' }}>
            <Skeleton
              variant="rectangular"
              width={100}
              height={20}
              sx={{
                borderRadius: '19px',
              }}
            />
          </Box>
          <Box sx={{ flex: 1, padding: '12px 16px' }}>
            <Skeleton variant="text" width="90%" height={24} />
          </Box>
          <Box
            sx={{
              width: 100,
              padding: '12px 16px',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Skeleton variant="circular" width={32} height={32} />
          </Box>
        </Box>
      ))}

      {/* Footer - Pagination */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          padding: '8px 16px',
          borderTop: `1px solid ${theme.palette.lightGray?.main || '#DCE0E7'}`,
          height: 52,
        }}
      >
        <Skeleton variant="text" width={300} height={32} />
      </Box>
    </Box>
  );
};

export default AgentMemorySkeleton;
